module.exports = __webpack_public_path__ + "static/media/hilo-dark.341eb1ca.svg";